// Module
var code = "<span class=\"time-display\"></span> &nbsp; <span translate=\"go-recorder-time-remaining-countdown_remaining-text\"></span>";
// Exports
module.exports = code;